import createIcon from '../../createIcon';

/**
 * @component @name WorkOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuNTA1MSAyMS4yNDUxTDIuNzU1MTIgMS40OTUxMkwxLjQ5NTEyIDIuNzU1MTJMNC4xOTUxMiA1LjQ1NTEySDMuNTU1MTJDMi40NDUxMiA1LjQ1NTEyIDEuNTY1MTIgNi4zNDUxMiAxLjU2NTEyIDcuNDU1MTJMMS41NTUxMiAxOC40NTUxQzEuNTU1MTIgMTkuNTY1MSAyLjQ0NTEyIDIwLjQ1NTEgMy41NTUxMiAyMC40NTUxSDE5LjE5NTFMMjEuMjQ1MSAyMi41MDUxTDIyLjUwNTEgMjEuMjQ1MVpNMjEuNTA1MSA3LjQ1NTEyQzIxLjU1NTEgNi4zNDUxMiAyMC42NjUxIDUuNDU1MTIgMTkuNTU1MSA1LjUwNTEySDE1LjU1NTFWMy40NTUxMkMxNS41NTUxIDIuMzQ1MTIgMTQuNjY1MSAxLjQ1NTEyIDEzLjU1NTEgMS41MDUxMkg5LjU1NTEyQzguNDQ1MTIgMS40NTUxMiA3LjU1NTEyIDIuMzQ1MTIgNy41NTUxMiAzLjQ1NTEyVjMuNzc1MTJMMjEuNTA1MSAxNy43NzUxVjcuNDU1MTJaTTEzLjU1NTEgNS41MDUxMkg5LjUwNTEyVjMuNDU1MTJIMTMuNTU1MVY1LjUwNTEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WorkOff = createIcon('WorkOff', [
  [
    'path',
    {
      d: 'M22.5051 21.2451L2.75512 1.49512L1.49512 2.75512L4.19512 5.45512H3.55512C2.44512 5.45512 1.56512 6.34512 1.56512 7.45512L1.55512 18.4551C1.55512 19.5651 2.44512 20.4551 3.55512 20.4551H19.1951L21.2451 22.5051L22.5051 21.2451ZM21.5051 7.45512C21.5551 6.34512 20.6651 5.45512 19.5551 5.50512H15.5551V3.45512C15.5551 2.34512 14.6651 1.45512 13.5551 1.50512H9.55512C8.44512 1.45512 7.55512 2.34512 7.55512 3.45512V3.77512L21.5051 17.7751V7.45512ZM13.5551 5.50512H9.50512V3.45512H13.5551V5.50512Z',
      key: '1h90pp',
    },
  ],
]);

export default WorkOff;
